export default {
  fields: {
    list: [
      {
        fieldName: "ticker",
        displayName: "Identifiant",
      },
    ],
    form: [
      {
        fieldName: "ticker",
        displayName: "IdeIdentifiantntifier",
      },
    ],
  },
};
